import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { ItemMapper } from "maps/ItemMapper";
import { unitsStore } from "units/_stores/unitsStore";
import { TCompare } from "properties/compare/_models/properties-favorite.model";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { CompareProps } from "properties/propertyCard/components/favorite/compare-provider";

interface Props {
    selectedItems: CompareProps[];
    category: React.ReactNode;
    content: (content: TCompare) => React.ReactNode | null;
}

export default function CompareModalTableBodyRow({ selectedItems, category, content }: Props) {
    return (
        <TableRow>
            <TableCell
                className="sticky left-0 bg-white z-0 bg-gray-100 font-medium text-sm md:text-base"
                style={{ width: 200 }}
            >
                <div>{category}</div>
            </TableCell>

            {selectedItems.map((contentItem, colIndex) => {
                if (contentItem.resource === COMMON_RESOURCE.PROPERTIES) {
                    const property = propertiesStore.getSync(contentItem.itemId);
                    const itemMapper = ItemMapper.toCompare(property, COMMON_RESOURCE.PROPERTIES);
                    return (
                        <TableCell key={colIndex} className={`text-center !align-top min-w-[225px]`}>
                            <div>{itemMapper && content(itemMapper)}</div>
                        </TableCell>
                    );
                }

                if (contentItem.resource === COMMON_RESOURCE.UNIT) {
                    const property = unitsStore.getSync(contentItem.itemId);
                    const itemMapper = ItemMapper.toCompare(property, COMMON_RESOURCE.UNIT);
                    return (
                        <TableCell key={colIndex} className={`text-center !align-top min-w-[225px]`}>
                            <div>{itemMapper && content(itemMapper)}</div>
                        </TableCell>
                    );
                }
            })}
        </TableRow>
    );
}
